const white = [
  /* 登录 */
  '/login',
  /* 验证手机号是否存在 */
  '/phoneNumIsExist',
  /* 验证邮箱是否存在 */
  '/emailIsExist',
  /* 注册 */
  '/register',
  /* 发送手机验证码 */
  '/sendSmsCode',
  /* 发送邮箱验证码 */
  '/sendEmailCode',
  /* 修改密码 */
  '/changePwd',
  /* 加载数据 */
  '/loadBaseData'
]

export default white